import { AsyncPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { SparePart } from '@ecs-features/result/spare-parts-result/spare-parts.interface';
import { TranslatePipe } from '@ngx-translate/core';
import { SelectableRow } from '@os-components';
import { SewButton, SewHeadline } from '@sew/ui-components-angular/standalone';
import { Observable } from 'rxjs';
import { PartsRecommendationComponent } from '../../../parts-recommendation/parts-recommendation.component';
import { PartDetailDescriptionComponent } from './part-detail-description/part-detail-description.component';
import { PartDetailService } from './part-detail.service';

@Component({
    selector: 'ecs-part-detail',
    templateUrl: './part-detail.component.html',
    styleUrls: ['./part-detail.component.scss'],
    imports: [
        SewButton,
        SewHeadline,
        PartDetailDescriptionComponent,
        PartsRecommendationComponent,
        AsyncPipe,
        TranslatePipe,
    ],
})
export class PartDetailComponent implements OnInit {
    public displayedSparePart!: Observable<SelectableRow<SparePart> | null>;
    public checkedRows!: Observable<SelectableRow<SparePart>[]>;

    public constructor(public partDetailService: PartDetailService) {}

    public ngOnInit(): void {
        this.displayedSparePart = this.partDetailService.getDisplayedItem$;
        this.checkedRows = this.partDetailService.getCheckedRows;
    }

    public selectPrevious() {
        this.partDetailService.selectPrevious();
    }

    public selectNext() {
        this.partDetailService.selectNext();
    }
}
